<template>
  <v-container>
    <v-flex xs12>
      <v-card>
        <v-flex xs12 px-4 v-if="err">
          <v-alert :value="true" type="error">{{err}}</v-alert>
        </v-flex>
        <v-card-title class="py-2 px-4 layout row wrap align-end">
          <h3>{{$lang.global.orderHistory}}</h3>
          <v-spacer />
          <v-text-field
            class="min-w max-w mx-2"
            v-model="search"
            append-icon="search"
            :label="$lang.labels.search"
            hide-details
          />
        </v-card-title>
        <v-data-table
          :headers="headers"
          :items="orderHistory"
          :search="search"
          :loading="loading"
          :pagination.sync="pagination"
          :rows-per-page-items="[50, 100, 250, 500, { text:'All' , value: -1 }]"
        >
          <v-progress-linear height="6" slot="progress" color="primary" indeterminate />
          <template slot="items" slot-scope="props">
            <td>{{ formatDate(props.item.createdOn) }}</td>
            <td>{{ $lang.actions[props.item.type] }}</td>
            <td><p :style="goDark ? 'color: white' : ''" :data-price="parseFloat(props.item.totalAmount).toFixed(2)" class="price" data-currency="₤">{{ parseFloat(props.item.totalAmount).toFixed(2) }}</p></td>
            <td class="text-xs-center">
              <v-btn
                name="viewOrder"
                color="primary" class="mx-0 elevation-0"
                @click="showModal(props.item)">
                {{$lang.actions.view}}
              </v-btn>
            </td>
          </template>
          <v-alert slot="no-results" :value="true" color="warning" icon="warning">
            {{$lang.errors.yourSearchFor}} "{{ search }}" {{$lang.errors.foundNo}}.
          </v-alert>
        </v-data-table>
      </v-card>
      <v-dialog v-if="orderDetails" v-model="orderDetails" max-width="1200">
        <order-details :order="order" @close="orderDetails = false"/>
      </v-dialog>
    </v-flex>
  </v-container>
</template>

<script>
  import moment from 'moment';
  import auth from '@/auth';
  import { mapGetters } from 'vuex';

  export default {
    components: {
      orderDetails: () => import('../modals/OrderDetails'),
    },
    data() {
      return {
        err: '',
        search: '',
        loading: true,
        orderDetails: false,
        orderData: null,
        orderHistory: [],
        pagination: {
          sortBy: 'createdOn',
          descending: true,
        },
        headers: [
          { text: this.$lang.labels.createdOn, value: 'createdOn', align: 'left' },
          { text: this.$lang.labels.deliveryType, value: 'type', align: 'left' },
          { text: this.$lang.labels.totalAmount, value: 'totalAmount', align: 'left' },
          { text: this.$lang.labels.actions, value: 'actions', sortable: false, align: 'center' },
        ],
      };
    },
    computed: {
      ...mapGetters({
        goDark: 'goDark',
      }),
    },
    methods: {
      showModal(order) {
        this.order = order;
        this.orderDetails = true;
      },
      formatDate(time) {
        return moment(time).format('YYYY-MM-DD HH:mm');
      },
    },
    created() {
      if (!auth.isLoggedIn()) {
        this.$router.push(`/${this.$lang.current_lang}/login`);
        return;
      }
      this.$http.get('order/getforuser')
        .then((res) => {
          if (res.body.status === 'Success') {
            this.loading = false;
            this.orderHistory = res.body.details;
            if (this.orderHistory.length === 0) {
              this.loading = false;
            }
            return;
          }
          this.err = res.body.statusText;
        }, (err) => {
          this.loading = false;
          this.err = err.body.statusText || err.body.message;
        });
    },
    destroyed() {
      this.orderHistory = [];
    },
  };
</script>

<style lang="scss" scoped>
  .min-w {
    min-width: 180px;
  }
  .max-w {
    max-width: 260px;
  }

  .price {
    min-width: 56px;
    display: inline-block;
    margin: 0;
    padding-left: 8px;
    position: relative;
    text-align: right;
    &:before {
      content: attr(data-currency);
      position: absolute;
      left: 0;
    }
    &.no-min {
      min-width: 1px;
    }
  }
</style>




// WEBPACK FOOTER //
// src/components/webshop/userOrderHistory/OrderHistory.vue